import { render, staticRenderFns } from "./TheCompareWidget.vue?vue&type=template&id=62915fd2&scoped=true&"
import script from "./TheCompareWidget.vue?vue&type=script&lang=js&"
export * from "./TheCompareWidget.vue?vue&type=script&lang=js&"
import style0 from "./TheCompareWidget.vue?vue&type=style&index=0&id=62915fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62915fd2",
  null
  
)

export default component.exports